import { selectors } from '../redux/reducers/User.js';
import store from '../redux/Store.js';

export const hasPrivilege = (privilege) => {
  const state = store.getState();
  return selectors.has_privilege(state, privilege);
};

export const hasOneofPrivileges = (privileges) => {
  const state = store.getState();
  return !!privileges.find((privilege) =>
    selectors.has_privilege(state, privilege)
  );
};
